import { render, staticRenderFns } from "./CostTable.vue?vue&type=template&id=2f53f4e3&scoped=true&"
import script from "./CostTable.vue?vue&type=script&lang=js&"
export * from "./CostTable.vue?vue&type=script&lang=js&"
import style0 from "./CostTable.vue?vue&type=style&index=0&id=2f53f4e3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f53f4e3",
  null
  
)

export default component.exports